export default {  
    employee: {
        cpf: null,
        nome: null,
        desconto: null,
        limite: null,
        cupom: null
    },
    showDialog: false
}